// extracted by mini-css-extract-plugin
export var RecruitVoice = "RecruitVoice-module--RecruitVoice--ii70B";
export var RecruitVoice__content = "RecruitVoice-module--RecruitVoice__content--3LM8Q";
export var RecruitVoice__lead = "RecruitVoice-module--RecruitVoice__lead--1f0C7";
export var RecruitVoice__list = "RecruitVoice-module--RecruitVoice__list--K7ySM";
export var RecruitVoice__listImg = "RecruitVoice-module--RecruitVoice__listImg--3kJtt";
export var RecruitVoice__listText = "RecruitVoice-module--RecruitVoice__listText--2SNLz";
export var RecruitVoice__listTextDep = "RecruitVoice-module--RecruitVoice__listTextDep--sZWoR";
export var RecruitVoice__listTextJoin = "RecruitVoice-module--RecruitVoice__listTextJoin--19JLe";
export var RecruitVoice__btn = "RecruitVoice-module--RecruitVoice__btn--3frM8";